import { BlogHomeElementDataType } from '@/components/sections/builder/elements/body/blog-home/type';
import { ElementProps } from '@/components/sections/builder/types';
import { WrapperChild } from '@/components/sections/builder/wrapper';
import { hexToRgb } from '@/lib/utils';
import { useBuilderStore } from '@/stores/builder';
import clsx from 'clsx';
import { shallow } from 'zustand/shallow';

export default function ElementContent({ element, preview }: ElementProps) {
  const childs = element.childs;

  const data = element.data as BlogHomeElementDataType;

  const builder = useBuilderStore(
    (state) => ({
      theme: state.theme,
      setTheme: state.setTheme,
    }),
    shallow
  );
  return (
    <>
      <section
        className={clsx(
          'font_color background-color',
          data.background?.type === 'color' && 'background-color',
          data.background?.type === 'image' && 'background-image'
        )}
      >
        <div className='theme_layout_page_width font_color mx-auto duration-100'>
          <div className='blog-post-padding relative'>
            {data.overlay && <div className={clsx('overlay absolute inset-0')} />}
            <div className='relative mx-auto max-w-screen-xl px-4 py-8 lg:px-6 lg:py-16'>
              <div
                className={clsx(
                  'mb-8 flex flex-col lg:mb-16',
                  data.contentAlign === 'left' && 'text-left [&>button>*]:text-left',
                  data.contentAlign === 'center' && 'text-center [&>button>*]:text-center',
                  data.contentAlign === 'right' && 'text-right [&>button>*]:text-right'
                )}
              >
                {(childs || []).map((child) => (
                  <WrapperChild
                    child={{
                      ...child,
                      parentData: data,
                    }}
                    parentType={element.type}
                    key={child.id}
                    preview={preview}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <style jsx>
        {`
          @media (min-width: 768px) {
            .blog-post-padding {
              padding-top: ${data.padding?.top || 0}px;
              padding-bottom: ${data.padding?.bottom || 0}px;
              padding-left: ${data.padding?.left || 0}px;
              padding-right: ${data.padding?.right || 0}px;
            }
            .full_width_blog_pos_list {
              width: calc(100vw - 20px);
              margin-left: calc(-50vw + 50% + 10px);
            }
          }

          .overlay {
            background-color: ${data.overlay};
          }

          .overlay {
            background-color: ${data.overlay
              ? hexToRgb(data.overlay, Number(data.overlayPercentage || 100))
              : 'transparent'};
          }

          .background-color-default {
            background-color: ${data.colorScheme?.background || 'white'};
          }

          .background-color {
            background-color: ${data.background?.backgroundColor ||
            data.colorSchemeBlogHome?.background};
            --tw-bg-opacity: ${data.background?.backgroundOpacity || 1};
          }

          .background-image {
            background-image: url(${data.background?.backgroundImage});
            background-repeat: no-repeat;
            background-size: ${data.background?.backgroundSize};
            background-position: ${data.background?.backgroundPosition};
            background-attachment: ${data.background?.backgroundAttachment === 'fixed'
              ? 'unset'
              : 'fixed'};
          }

          .font_color {
            color: ${data.colorSchemeBlogHome?.text || builder.theme.blogCard?.colorScheme?.text};
          }
        `}
      </style>
    </>
  );
}
